module.exports = __webpack_public_path__ + "img/ics_o_profile_active.97ef5e02.svg";